import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../../contants/application_contants';

export default function Hack4tts_Intro({ section_id }) {
    // card definitions
    const cards = [
      {
        icon: application_contants.micicon ,
        title: 'Accent Transfer',
        text:  'India’s linguistic diversity means that speech patterns—including accents and styles—can vary significantly even within the same language. However, existing datasets often lack adequate representation of these variations.'
      },
      {
        icon: application_contants.styleicon ,
        title: 'Style Transfer',
        text:  'Style transfer techniques help TTS systems generate expressive speech by mimicking prosody, rhythm, and emotion from short reference samples. Recent methods involve disentangling speech components and using advanced prosody modeling to synthesize speech that closely mirrors the desired style—even in zero-shot and cross-lingual settings.'
      },
      {
        icon: application_contants.globalicon ,
        title: 'Text Normalization',
        text:  'Indian languages often contain script variations, abbreviations, numerals, and frequent code-switching. Text normalization ensures that such inputs are transformed into a standard form suitable for speech synthesis. Techniques range from rule-based approaches (e.g., WFSTs) to neural encoder-decoder models or hybrid systems that classify and normalize semiotic tokens. Proper normalization enables fluent, accurate, and natural-sounding output, especially critical in real-world applications.'
      }
    ]
  return (
    <section id={section_id} className="about-readmore-section">
      <div className="about-content">
        {/* <p className="about-subtitle title-navy-blue">Know More About us</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Introduction </h2>
        <p className="jostRegular h5-small section-title title-dark-grey about-readmore-text">
          The development of Text-to-Speech (TTS) systems tailored to low-resource Indian languages has the potential to revolutionize accessibility, education, and digital communication across diverse regions. This hackathon aims to address the challenge of creating TTS models that support accent and style transfer for SYSPIN's 9 languages (Hindi, Bengali, Marathi, Telugu, Bhojpuri, Kannada, Magadhi, Chhattisgarhi, and Maithili), as well as languages of SPICOR TTS corpora, namely, English and Gujarati. By leveraging open-source datasets and fostering innovation, the Challenge seeks to advance TTS technology for underrepresented languages and styles, empowering communities with localized and expressive voice synthesis. The winning model will be used in an LLM based assistant for pregnant women in low income communities in collaboration with Armman, to enhance maternal and child healthcare delivery.
        </p>
        
      </div>


      <div className="introduction-challenge-cards">
        {cards.map(({ icon, title, text }) => (
          <div key={title} className="introduction-challenge-card">
            <div className="card-icon">
              <img src={icon} alt="" />
            </div>
            <h3>{title}</h3>
            <p className="jostRegular h6-small section-title about-box-text">{text}</p>
          </div>
        ))}
      </div>

{/* 
      <div className="about-logos">
        <img src={application_contants.bhashinilogo } alt="Bhashini" />
        <img src={application_contants.iisclogo }      alt="IISc"      />
        <img src={application_contants.artparklogo }   alt="Artpark"   />
        <img src={application_contants.gizlogo }       alt="GIZ"       />
        <img src={application_contants.armmanlogo }   alt="Sammaan"   />
      </div> */}

    </section>
  )
}

Hack4tts_Intro.propTypes = {
  section_id: PropTypes.string.isRequired
}
